import * as React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CircularProgress from "@mui/material/CircularProgress";

function sleep(delay = 0) {
  return new Promise((resolve) => {
    setTimeout(resolve, delay);
  });
}

export default function SectorAutoComplete({
  sectorHandler,
  values,
  names,
  groupName
}) {
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const loading = open && options.length === 0;


const SECTORS = {
    Agriculture: 0,
    Construction: 1,
    Finance: 2,
    Education: 3,
    ICT: 4,
    Energy: 5,
    Entertainment: 6,
    Health: 7,
    Hospitality: 8,
    Manufacturing: 9,
    Mining: 10,
    Telecommunications: 11,
    Transportation: 12
  };

  const sectorOptions = Object.keys(SECTORS).map((sector) => ({
    label: sector,
    value: SECTORS[sector]
  }));
  

  React.useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    (async () => {
      await sleep(1e3);
      if (active) {
        setOptions(sectorOptions);
      }
    })();

    return () => {
      active = false;
    };
  }, [loading]);

  React.useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      event.stopPropagation();
    }
  };

//   React.useEffect(()=>{
//     console.log(values, "A town hall inddeed")
//   },[values])

  return (
    <>
        <br/>
      <Autocomplete
       name ={names}
        onKeyDown={handleKeyDown}
        autoHighlight
        id="asynchronous-demo"
        open={open}
        onOpen={() => {
          setOpen(true);
        }}
        onClose={() => {
          setOpen(false);
        }}
        value={values || {label:"All", value:0}}
        onChange={(event, value) => {
            debugger
          if (value) {
            sectorHandler(event, value, names);
            // updateValue(value);
          }
        }}
        isOptionEqualToValue={(option, value) => option?.label === value?.label}
        getOptionLabel={(option) => option?.label || ""}
        options={options}
        loading={loading}
        renderInput={(params) => (
          <TextField
            {...params}
            size="small"
            label={groupName}
            variant="standard"
            InputProps={{
              ...params.InputProps,
              endAdornment:
                <React.Fragment>
                  {loading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
             
            }}
          />
        )}
      />
    </>
  );
}
